// src/MarkdownRenderer.tsx
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { jsx } from "react/jsx-runtime";
var BR_ONLY_RE = /^(?:<br\s*\/?>\s*)+$/i;
var BR_TAG_RE = /<br\s*\/?>/gi;
function remarkBreakTags() {
  return (tree) => {
    const visit = (node) => {
      if (!Array.isArray(node.children)) return;
      for (let i = 0; i < node.children.length; i += 1) {
        const child = node.children[i];
        if (child?.type === "html" && typeof child.value === "string" && BR_ONLY_RE.test(child.value.trim())) {
          const count = (child.value.match(BR_TAG_RE) || []).length;
          const breaks = Array.from({ length: count }, () => ({ type: "break" }));
          node.children.splice(i, 1, ...breaks);
          i += breaks.length - 1;
        } else if (child && typeof child === "object") {
          visit(child);
        }
      }
    };
    visit(tree);
  };
}
function remarkAttachmentRows() {
  return (tree) => {
    const children = [];
    for (const node of tree.children) {
      if (node.type === "paragraph" && node.children.some((child) => child.type === "image") && node.children.every((child) => child.type === "image" && child.alt === "ASSET" && child.url.startsWith("asset_") || child.type === "text" && !child.value.trim() || child.type === "break")) {
        const images = node.children.filter((child) => child.type === "image");
        const previous = children[children.length - 1];
        if (previous?.type === "paragraph" && previous.data?.hProperties?.className?.includes("photon-markdown__attachments")) {
          previous.children.push(...images);
        } else {
          children.push({
            ...node,
            children: images,
            data: { ...node.data, hName: "div", hProperties: { className: ["photon-markdown__attachments"] } }
          });
        }
      } else {
        children.push(node);
      }
    }
    tree.children = children;
  };
}
var MarkdownRenderer = ({
  content,
  className = "",
  remarkPlugins = [remarkGfm],
  components,
  ...markdownProps
}) => /* @__PURE__ */ jsx("div", { className: `photon-markdown ${className}`.trim(), children: /* @__PURE__ */ jsx(
  ReactMarkdown,
  {
    ...markdownProps,
    remarkPlugins: [...remarkPlugins ?? [], remarkBreakTags, remarkAttachmentRows],
    components: {
      table: ({ children }) => /* @__PURE__ */ jsx("div", { className: "photon-markdown__table-scroll", role: "region", "aria-label": "Scrollable table", tabIndex: 0, children: /* @__PURE__ */ jsx("table", { children }) }),
      ...components
    },
    children: content
  }
) });
var MarkdownRenderer_default = React.memo(MarkdownRenderer);
export {
  MarkdownRenderer_default as default
};
